import styled from '@emotion/styled';

export default styled('div')`
  max-width: ${p => p.size || '900px'};
  margin: 1rem auto;
  line-height: 1.5rem;
  letter-spacing: 0.1rem;
`;
